import { registerPlugin } from '@capacitor/core'

import type { GoogleFitPlugin } from './GoogleFitDefinitions'

const GoogleFit = registerPlugin<GoogleFitPlugin>('GoogleFit')

export { GoogleFit }
